import React from 'react';
import { grey } from '@mui/material/colors';
import { Radio, Stack } from '@mui/material';
import { EquipmentCardContent } from 'components/shared/EquipmentCardContent';

import { InventoryEquipmentItem } from '../../../api';
import { ProspectiveUnitFlag } from '../../components/ProspectiveUnitFlag';
import { CURRENT_USER_DEFAULT_COLOR } from '../../../../dealActivity/calendar/constants';

interface Props {
  item: InventoryEquipmentItem;
  selected: boolean;
  onSelect: (id: string) => void;
  onViewUnit: (equipmentId: string) => void;
}

export const EquipmentItemCard = ({ item, selected, onSelect, onViewUnit }: Props) => (
  <Stack
    direction="row"
    flexWrap="wrap"
    sx={{
      gap: '1rem',
      minHeight: '7rem',
      borderRadius: '0.5rem',
      padding: '0.5rem 1rem',
      alignItems: 'flex-start',
      border: `1px solid ${selected ? CURRENT_USER_DEFAULT_COLOR : grey[300]}`,
      cursor: 'pointer',
    }}
    onClick={() => onSelect(item.equipment.id)}
  >
    <Radio checked={selected} size="small" sx={{ padding: '4px' }} />

    <EquipmentCardContent equipment={item.equipment} onViewUnit={onViewUnit} />

    <ProspectiveUnitFlag item={item} />
  </Stack>
);
